import { createQueryConfig } from "@utils/queryConfig"
import {
	QueryKeys,
	AppEvents,
	AvailableLanguages,
	StorageKeys
} from "@utils/user-config"
import {
	AEMOptions,
	AEMContentParams,
	AEMPageType
} from "@AEM/models/AEMPage.model"
import { useEffect, useState } from "react"
import { useAuthContext } from "@context/AuthProvider"
import {
	AVAILABLE_UNAUTHENTICATED_PAGES,
	fetchAEMContent
} from "@AEM/AEMContentLoader"
import secureLocalStorage from "react-secure-storage"
import { useQuery } from "@tanstack/react-query"
import { AEMResponse } from "@AEM/models/AEMResponse.model"
export const useAEMContent = (
	page: AEMPageType,
	options?: Exclude<AEMOptions, "enabled">,
	enabled = true
) => {
	const [locale, setLocale] = useState(
		secureLocalStorage.getItem(StorageKeys.USER_PREFERRED_LANGUAGE) ||
			AvailableLanguages.EN_US
	)
	const { userProfile, isLoading: isAuthLoading } = useAuthContext()
	useEffect(() => {
		const handleLanguageChange = () => {
			setLocale(
				secureLocalStorage.getItem(StorageKeys.USER_PREFERRED_LANGUAGE) ||
					AvailableLanguages.EN_US
			)
		}
		window.addEventListener(
			AppEvents.USER_LANGUAGE_CHANGED,
			handleLanguageChange
		)
		return () =>
			window.removeEventListener(
				AppEvents.USER_LANGUAGE_CHANGED,
				handleLanguageChange
			)
	}, [])
	const customQueryParams = options?.queryParams ?? {}

	const defaultQueryParams: AEMContentParams = {
		locale: locale as string,
		role: userProfile?.roleCode,
		office: userProfile?.reportingOfficeCode,
		country: userProfile?.countryCode
	}
	const finalQueryParams = {
		...defaultQueryParams,
		...customQueryParams
	}

	const optionParams = {
		brand: options?.brand,
		ship: options?.ship,
		pathParams: options?.pathParams
	}
	return useQuery<AEMResponse, Error>({
		queryKey: [QueryKeys.AEM_CONTENT, page, finalQueryParams, optionParams],
		queryFn: () =>
			fetchAEMContent(page, {
				...options,
				queryParams: finalQueryParams
			}),
		...createQueryConfig<AEMResponse, Error>(),
		enabled:
			!isAuthLoading &&
			(AVAILABLE_UNAUTHENTICATED_PAGES.includes(page) || !!userProfile) &&
			enabled
	})
}
